import {
  DateFormatAttribute,
  LanguageAttribute,
  PropertyAttribute,
  TimeZoneAttribute,
  User,
  UserProfile,
} from '@bimone/bimtrack-core';
import { UserPersistDto } from '../types';

export function serializeUser(user?: User): UserPersistDto | undefined {
  if (!user) {
    return undefined;
  }

  const {
    id: userId,
    globalId,
    email,
    profile: {
      firstName,
      lastName,
      title,
      company,
      country,
      industry,
      jobTitle,
      dateFormat: { id: dateFormatId, name: dateFormatName, format },
      avatarImage,
      language: { id: languageId, name: languageName },
      timeZone: { id: timeZoneId, name: timeZoneName, nameIana, offset },
    },
  } = user;

  return {
    id: userId,
    globalId: globalId,
    email: email,
    profile: {
      firstName,
      lastName,
      title,
      company,
      country: country ? { id: country.id, name: country.name } : undefined,
      industry: industry ? { id: industry.id, name: industry.name } : undefined,
      jobTitle,
      dateFormat: { id: dateFormatId, name: dateFormatName, format },
      avatarImage,
      language: { id: languageId, name: languageName },
      timeZone: { id: timeZoneId, name: timeZoneName, nameIana, offset },
    },
  };
}

export function deserializeUser(user?: UserPersistDto): User | undefined {
  if (!user) {
    return undefined;
  }

  const {
    id: userId,
    globalId,
    email,
    profile: {
      firstName,
      lastName,
      title,
      company,
      country,
      industry,
      jobTitle,
      dateFormat: { id: dateFormatId, name: dateFormatName, format },
      avatarImage,
      language: { id: languageId, name: languageName },
      timeZone: { id: timeZoneId, name: timeZoneName, nameIana, offset },
    },
  } = user;

  return new User({
    id: userId,
    globalId,
    email,
    profile: new UserProfile({
      firstName,
      lastName,
      title,
      company,
      country: country ? new PropertyAttribute({ id: country.id, name: country.name }) : undefined,
      industry: industry ? new PropertyAttribute({ id: industry.id, name: industry.name }) : undefined,
      jobTitle,
      dateFormat: new DateFormatAttribute({ id: dateFormatId, name: dateFormatName, format }),
      avatarImage,
      language: new LanguageAttribute({ id: languageId, name: languageName }),
      timeZone: new TimeZoneAttribute({ id: timeZoneId, name: timeZoneName, nameIana, offset }),
    }),
  });
}
